import { createContext } from 'react';

export const ActionsContext = createContext({ isActive: false, concernGuid: null });
